import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { catchError, tap } from "rxjs/operators";

@Injectable()
export class ErrorInterceptorService implements HttpInterceptor {
  constructor(private router: Router, private toastr: ToastrService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((res: any) => {
        return res;
      }),
      catchError((err: HttpErrorResponse) => {
        // debugger
        if (err.status === 400) {
          if (err.error.message) {
            this.toastr.error(err.error.message);
            // alert(err.error.message);
          } else {
            this.toastr.error(JSON.stringify(err.error.errors));
          }
        }
        throw err;
      })
    );
  }
}
